export function fileHandler(file: any, setImgStatus: (key: string, value: string) => void, updateImage: (name:any, value:any) => void): void {
    if (file) {
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const maxSize = 700 * 1024;
  
        // Validate file type
        if (!validTypes.includes(file.type)) {
            setImgStatus("setEditOrganizationDetails", "Допустимые форматы JPG, JPEG, and PNG")
          return;
        }

        // Validate file size
        if (file.size > maxSize) {
            setImgStatus("setEditOrganizationDetails", "Допустимый размер менее 700KB.")
            return;
        }

        // Clear previous errors
        setImgStatus("setEditOrganizationDetails","")

        updateImage('imagePreview' , file)
        // Create a preview URL for the selected image
    }
}